/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

/* eslint-disable no-duplicate-imports */
import * as React from 'react';
import { Button } from '@msdyn365-commerce-modules/utilities';
import { INosTextBlockViewProps } from './nos-text-block';
import { LinksButtonType } from './nos-text-block.props.autogenerated';

const NosTextBlockView: React.FC<INosTextBlockViewProps> = props => {
    const config = props.config;

    return (
        <div className={props.className} id={props.id} {...props.renderModuleAttributes(props)}>
            <div className={config.layout === 'row' ? 'nos-text-block__layout-row' : 'nos-text-block__layout-column'}>
                {props.pictogram}
                {props.paragraph}
            </div>
            {config.links && (
                <div className='nos-text-block__button-group'>
                    {config?.links?.map((link, index) => {
                        return (
                            <Button
                                key={index}
                                href={link.linkUrl.destinationUrl}
                                type='button'
                                className={`${
                                    link?.buttonType === LinksButtonType.primaryDark
                                        ? 'ms-button__primary-dark'
                                        : link?.buttonType === LinksButtonType.primaryLight
                                        ? 'ms-button__primary-light'
                                        : link?.buttonType === LinksButtonType.secondaryDark
                                        ? 'ms-button__secondary-dark'
                                        : link?.buttonType === LinksButtonType.secondaryLight
                                        ? 'ms-button__secondary-light'
                                        : ''
                                }`}
                            >
                                {link.linkText}
                            </Button>
                        );
                    })}
                </div>
            )}
        </div>
    );
};

export default NosTextBlockView;
